import StandardForm from "./Form/StandardForm";
import DarkModeForm from "./Form/DarkModeForm";
import StepperListForm from "./Form/StepperListForm";
import { useStoreState } from "../store";
import { FormTypes } from "../constants";

export default function Form() {
  const { settings } = useStoreState();
  const { formType } = settings;
  let formComponent = <StandardForm />;
  if (formType === FormTypes.DarkMode) {
    formComponent = <DarkModeForm />;
  }
  if (formType === FormTypes.StepperList) {
    formComponent = <StepperListForm />;
  }

  return <div id="form-wrapper" className="form-wrapper">{formComponent}</div>;
}
